document.addEventListener('DOMContentLoaded', function() {
  GeoRedirect.fetchData(function (location) {
    var currentCountry = location.country_code;
    var excludingCountries = ['IQ', 'EG', 'LB', 'SY', 'PS', 'YE', 'IL', 'TR', 'MX', 'MA'];
    var sportswearOnlyCountries = ['IL', 'TR', 'MX', 'MA', 'MY'];

    var excludingMEV1 = [];
    var excludingMEV3 = ['IQ', 'EG', 'MA'];
    var excludingMEV4 = [];


    var DEV = false && location.ip == '80.109.151.154';

    if (excludingCountries.indexOf(location.country_code) !== -1 || DEV) {

      var isSportswearOnly = sportswearOnlyCountries.indexOf(location.country_code) !== -1;

      
      function isFitnessLink(href) {
        return href.indexOf('fitness') !== -1;
      }

      function removeNode(node) {
        if (typeof node === 'undefined' || node === null) {
          return;
        }
        if (typeof node.remove !== 'function') { // IE
          if (node.parentNode === null) {
            return;
          }
          node.parentNode.removeChild(node); 
        } else {
          node.remove();
        }
      }

      function removeFitnessLinks(nodeList) {
        for (var i = 0; i < nodeList.length; i++) {
          if (isFitnessLink(nodeList[i].href) && window.location.pathname !== '/') {
            removeNode(nodeList[i]);
          }
        }
      }


      function modifyFitnessAddToCartButton(node) {
        if (typeof node === 'undefined' || node === null) {
          return; 
        }
        node.setAttribute('disabled', true);
        node.style.color = '#000';
        node.style.background = '#f5f5f5';
        node.style.pointerEvents = 'none';
        node.style.display = 'flex';
        node.style.alignItems = 'center';
        node.style.justifyContent = 'center';
        var nodeSpan = node.querySelector('span');
        if(nodeSpan !== null){
        nodeSpan.style.fontSize = '12px';
        nodeSpan.style.whiteSpace = 'normal';
        nodeSpan.innerText = 'From your country it\'s only possible to order Sportswear';
          }
      }

      if (isSportswearOnly) {
        if (window.location.pathname === '/') {
          window.location.replace('https://www.womensbest.com/pages/sportswear');
        }
      }

      if (isFitnessLink(window.location.href)) {
        window.location.replace('https://www.womensbest.com/pages/sportswear');
      }

      removeFitnessLinks(document.querySelectorAll('a'));
      removeNode(document.getElementById('headersearchtoggle'));
      removeNode(document.getElementById('headersearchtoggle-mobile'));
      
     

      if (document.querySelector('.fitness-info-flex') !== null) {
        var nodeList = document.querySelectorAll('.wb-single-product_meta-container .wb-product-addtocart-btn');
        for (var i = 0; i < nodeList.length; i++) {
          modifyFitnessAddToCartButton(nodeList[i]);
        }
      }

      if (document.querySelector('.bp-refer-friends') !== null) {
        removeNode(document.querySelector('.bp-refer-friends'));
      }


      
      if (document.querySelector('.regulation-country') !== null) {
        document.querySelector('.regulation-country').innerHTML = location.country_name;
      }

      removeNode(document.querySelector('#wb-hdr19 .wb-hdr19-main a[data-href="#flyout-athlete-series"]'));
      removeNode(document.querySelector('#sidenav-main .wb-header__sidenav__main__panel__list a[href="#sidenav-athlete-series"]'));

      if (isSportswearOnly) {
        removeNode(document.querySelector('#wb-hdr19 .wb-hdr19-main a[data-href="#flyout-fitness"]'));
        removeNode(document.querySelector('#wb-hdr19 .wb-hdr19-main a[data-href="#flyout-beauty"]'));
        removeNode(document.querySelector('#wb-hdr19 .wb-hdr19-main a[data-href="#flyout-foods"]'));
        if(document.querySelector('#wb-product-ctl-nutrition') !== null){
        document.querySelector('#wb-product-ctl-nutrition').remove();
        }

        if (document.querySelector('.mexican-sportswear-alert') !== null) {
          document.querySelector('.mexican-sportswear-alert').style.display = 'block';
        }
      }

    }
  
    if (excludingMEV3.indexOf(location.country_code) !== -1 || window.location.hash === '#v3') {
      document.querySelector('.wb-arabic-general').style.display = 'none';
      document.querySelector('.wb-arabic-v1').style.display = 'none';
      document.querySelector('.wb-arabic-v2').style.display = 'none';
      document.querySelector('.wb-arabic-v3').style.display = 'block';
      document.querySelector('.wb-arabic-v4').style.display = 'none';
    }
  });
});